export const MIN_STRING_LENGTH = 10;
export const TOOLTIP_DELAY = 1500;

export const TABS = {
  TASKS: 'TASKS',
  RECOGNITIONS: 'RECOGNITIONS',
  BROADCASTS: 'BROADCASTS',
};
